import React from 'react'
import Modal from '@material-ui/core/Modal';
import Loading from 'components/Loading'
import { Button } from '@material-ui/core';

import style from 'style/chat/ModalLockRoom.css';

class ModalLockRoom extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      loading: false,
      action: null
    }
  }
  handleClose = () => {
    this.setState({ open: false })
  }

  openModal = (action) => {
    this.setState({ open: true })
    if (action) this.setState({ action })
  }

  onLockRoom = async () => {
    this.showLoading()
    this.state.action()
    this.hideLoading()
    this.handleClose()
  }

  onTextInputHandle = (event) => {
    this.setState({ ddx: event.target.value })
  }

  showLoading = () => {
    this.setState({ showLoading: true })
  }
  hideLoading = () => {
    this.setState({ showLoading: false })
  }
  render() {
    return (
      <Modal

        open={this.state.open}
        onClose={this.handleClose}
      >
        <div className="modal-lock-room">
          <div className="description">
            <p>این آخرین پیام شماست</p>
            <span>تنها یک پیام یا عکس دیگر میتوانید برای پزشک ارسال کنید. پس از ارسال پیام گفتگوی شما بسته خواهد شد. آیا از ارسال این پیام اطمینان دارید؟</span>
          </div>
          <div className="modal-action">
            {this.state.loading && <div className="Loading"><Loading /></div>}
            <Button onClick={this.handleClose}>انصراف</Button>
            <Button className='primary-action' onClick={this.onLockRoom}>تایید</Button>
          </div>
        </div>
      </Modal>
    )
  }
}
export default ModalLockRoom